import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import SimpleCheckbox from '../simpleCheckbox';
import config from '../../../config';
import WorkDayConflictIconWithTooltip from './workDayConflictIconWithTooltip';
import { t } from '../../../modules/infra/i18n';

const getDayName = (isoWeekday) => {
  const dayMap = {
    1: 'monday',
    2: 'tuesday', 
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
    7: 'sunday'
  };
  
  return t(`barber:schedule.days.${dayMap[isoWeekday]}`);
};

const WorkdayInput = (props) => {
  const dayName = getDayName(props.input.value);

  return (
    <div className="o-flexbox__item">
      <SimpleCheckbox
        key={props}
        label={dayName}
        id={props.enabledName}
        name={props.enabledName}
        disabled={props.disabled}
        containerClass="c-checkbox u-mr--"
      />
      <WorkDayConflictIconWithTooltip
        dayConflicts={props.dayConflicts}
        display-if={props.dayHasConflicts}
      />
    </div>
  );
};

WorkdayInput.propTypes = {
  dayConflicts: PropTypes.arrayOf(PropTypes.shape({})),
  dayHasConflicts: PropTypes.bool,
  disabled: PropTypes.bool,
  enabledName: PropTypes.bool.isRequired,
  input: PropTypes.shape({
    value: PropTypes.bool.isRequired,
  }).isRequired,
};

WorkdayInput.defaultProps = {
  dayConflicts: [],
  dayHasConflicts: false,
  disabled: false,
};

export default WorkdayInput;
